<template>
  <div class="home home_i api-c" ref="scrollContainer"  style=' background: #f5f5f5;'>
    <div class="home-header">
      <headerTop :opacity="opacity" />
      <div style="    width: 98%;
    margin: 0 auto;">
        <div style="text-align: left; margin-bottom: 10px" class="api-content">
          <!-- <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">返回</el-breadcrumb-item>
            <el-breadcrumb-item>api手册</el-breadcrumb-item>
          </el-breadcrumb> -->
          <!-- <el-input
            v-model="seach"
            placeholder="请输入您要查询的API"
            style="width: 700px; border-radius: 40px"
            @blur="initSeach"
            @keyup.enter.native="initSeach"
            size="small"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i
          ></el-input> -->
        </div>
        <div style="display: flex;justify-content: center;">
          <!-- <silber></silber> -->
            <!-- <response></response> -->
            <!-- 子路由内容展示区 -->
            <router-view />
        </div>
       
      </div>
    </div>
    <el-backtop target=".home" :bottom="100" :right="40" class="custom-backtop">
      <i class="el-icon-caret-top"></i>
    </el-backtop>
  </div>
</template>
  
  <script>
// @ is an alias to /src
// import silber from "./components/silber.vue";
import headerTop from "@/components/headerTop.vue";
import response from "./components/response.vue";

export default {
  name: "Home",
  components: {
    // silber,
    headerTop,
    response,
  },
  data() {
    return {
      seach: "",
      activeName: "api",
      opacity: 0,
    };
  },
  mounted() {
    // 获取滚动容器（height:calc(100vh - 60px) 的 div）
    const scrollContainer = this.$refs.scrollContainer;

    scrollContainer.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    const scrollContainer = this.$refs.scrollContainer;
    scrollContainer.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll(e) {
      // 滚动到底部判断（距离底部50px时触发）
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      this.isFixed = scrollTop >= this.tabTop;
      // if (scrollHeight - scrollTop - clientHeight < 50) {
      //   this.loadMoreCourses()
      // }
      if (scrollTop > 38) {
        this.opacity = true;
      } else {
        this.opacity = false;
      }
    },
  },
};
</script>
  <style scoped>
.home {
  height: 100vh;
  background: #ffffff;
  overflow: auto;
}
.api-content {
  padding-top: 80px;
  min-width: 1200px;
  /* width: 1400px; */
  max-width:92rem;
  padding-left: 2rem;
  padding-right: 2rem;
  margin: 0 auto;
  display: flex;
}
/deep/.el-tabs__nav-scroll,
/deep/.el-tabs__content {
  /* width: 1400px; */
  padding-left: 2rem;
  padding-right: 2rem;
  max-width:92rem;
  min-width: 1200px;
  margin: 0 auto;
}
/deep/.el-breadcrumb{
  margin-top:10px;
  margin-right:50px;
}

</style>